export const BEAR       = 'bear'
export const BIRD       = 'bird'
export const BUNNY      = 'bunny'
export const BUTTERFLY  = 'butterfly'
export const CAT        = 'cat'
export const COW        = 'cow'
export const DOG        = 'dog'
export const EAGLE      = 'eagle'
export const ELEPHANT   = 'elephant'
export const FOX        = 'fox'
export const GIRAFFE    = 'giraffe'
export const GORILLA    = 'gorilla'
export const LADYBUG    = 'ladybug'
export const LION       = 'lion'
export const LOBSTER    = 'lobster'
export const MOUSE      = 'mouse'
export const RACCOON    = 'raccoon'
export const SNAKE      = 'snake'
export const TURTLE     = 'turtle'



// WEBPACK FOOTER //
// ./app/lib/avatars.js